/* Add p_tableData to toolbar Fe 26 2022 */
/* Add Team Availability Gantt to Team Memebers Table May 8, 2022 */
/* Exclude GANTTVIEW June 19, 2022 */
/* Add Pdf Reports Mar 25, 2023 */
/* Add fn_addCustomData Jul 17, 2023 */
/* Add filtered to Pagination and Filter Value to Aggregates Oct 7, 2023 */
/* Amend filter option array to object for !hasRefData  Oct 7, 2023 */
/* Add if(!colAaggrNf) return;  Nov 14, 2023 */
/* Add fn_hrefLink, fn_hrefAppLink   Nov 18, 2023 */
/* Amend use Math.min(...values) && Math.max(...values) Jan 20 2024 */
/* Add p_sort, p_filters for kt-toolbar Feb 3, 2024 */
/* Remove QuickSearch  Mar 2, 2024 */
/* Add eventBus to emit table change Apr 13, 2024*/
/* Amend filter_data[key].data to check includes July 6, 2024 */;
/* Amend m_sortClick to sort all columns July 20, 2024 */
/* Add SortColumn to local storage Aug 3, 2024 */
/* Add using util.fn_timeFmt for time customfields Aug 8, 2024 */
/* Add m_valFmtTbl  for "tel" columns Aug 24, 2024 */
/* Amend for Front End Pagination Sep 11, 2024 */
/* Move search to Front End Oct 5, 2024 */
/* Move Quick Filters to Front End Dec 7, 2024 */
/* Emergency Pagination Bug fix Dec 28, 2024 */
/* Add readOnly columns Feb 1, 2025 */
/* Add  Table edit March 22, 2025 */
/* Amend for related:true  March 29, 2025 */
/* Add Notes/Comments  May 31, 2025 */
/* Amend fn_detailToggle June 21, 2025 */
/* Bug fix for Opportunity value and psqft Aug 16, 2025 */
/* Add processing of dashboard dblclick filters, c_tblMinWidth, refData Oct 25, 2025 */
/* Add lastContactDate quick filter Feb 28, 2026 */
/* Amend psqft calculation  Apr 30, 2026 */
/* Add style for team|extr, profilePicturePath,api_baseURL on fn_detailToggle May 15, 2026 */
/* Add p_appEnt to kt-table-column-edit,m_savedNotes  Jul 11, 2026 */
/* Add businessCardUpload, amend created Jul 18, 2026 */
<template lang="pug">
	div(class="kt-table text-left")
		//- Toolbar
		kt-toolbar(v-if="d_altViewKey != 'GANTTVIEW'" :p_enableSearch="d_opts.enableSearch"
				:p_getData="m_getData" :p_altViewKey="d_altViewKey" :p_cols="d_cols" :p_sort="d_dataParams.order" 
				:p_tableData="d_filteredData" :p_tblId="d_id" :p_columns="d_cols" :p_tableName="d_tableName" :p_appEntKey="p_appEntKey" :p_filterData="c_filters" 
				:p_filters="d_filters" @filters="m_filterTableData" @clearFilters="m_clearFilters" :p_tableEdit="c_editedColumns" @save="m_saveTableEdit" 
				@cancel="m_cancelTableEdit" @search="m_searchMode($event)" :p_showBtns="p_showBtns")
			template(v-slot:toolbar-left)
				span(v-if="d_altViewKey != 'MAPVIEW'" class="statusHeader") {{p_tbNote || d_appEnt.label}}
				kt-tt-info(:p_infoTxt="p_tbInfo" v-if="p_tbInfo")
				b-button(v-if="!p_tbInfo && p_tblIdKey != '-team-rr' && /^(Opportunities)$/.test(d_appEnt.label) && d_altViewKey != 'MAPVIEW'" class="btn-alt-view" variant="outline-secondary"  @click="m_mapView")
						fa-icon(icon="map")
						|Map view
				b-button(v-if="/^(Team Members)$/.test(d_appEnt.label) && d_altViewKey != 'GANTTVIEW'" class="btn-alt-view" variant="outline-secondary"  @click="m_ganttView")
						fa-icon(icon="chart-line")
						|Workload Management
				b-button(v-if="/^(Opportunities|Team Members)$/.test(d_appEnt.label) && /^(GANTTVIEW|MAPVIEW)$/.test(d_altViewKey)" class="btn-back"  title="Back" variant='primary' @click="d_altViewKey=null")
					fa-icon(icon="arrow-left")
		//- kt-quickSearch(v-if="/^(Opportunities)$/.test(d_appEnt.label) && /^(MAPVIEW)$/.test(d_altViewKey)" :p_dataColumns="d_quickSearchColumns" @filters="m_filterTableData" @clearFilters="m_clearFilters")
			template(v-slot:toolbar-right-l v-if="d_opts.enableCUFilter" )
				b-button(class="btn-cuFilter" :class="d_qryPrms.currentUser?'filtered':null" variant="none"
					v-b-tooltip.hover.auto.ds500="{title:'Filter My ' + d_appEnt.label}"
					@click="m_currentUser")
					//- fa-icon(:icon="d_qryPrms.currentUser? 'user-check' : 'user-alt'")
					fa-layers
						fa-icon(icon="user-alt")
						fa-icon(:icon="['fas', 'filter']" transform="shrink-6 up-5 left-10" v-show="d_qryPrms.currentUser")
		template(v-if="d_altViewKey=='GANTTVIEW'")
			kt-ganttView(v-if="d_altViewKey=='GANTTVIEW'" :p_taskData="d_taskData")
		template(v-if="d_altViewKey=='MAPVIEW'")
			kt-mapView(v-if="d_altViewKey=='MAPVIEW'" :p_mapData="d_filteredData" :p_refData="d_refData")
		div(id="tableDiv" v-if="!d_altViewKey" class="kt-table-table" :style="c_tblStyle")
			//- Table
			b-table-simple(id="tableRows" small hover :style="{'min-width':c_tblMinWidth}" table-class="sortable")
				b-thead(:class="{'popup': p_popupParams != null,'regular':p_popupParams == null}") 
					b-th(v-if="d_opts.detailView" class="th-detail")
					b-th(v-for="col in c_colsVisible" :key="col.field" 
						:class="{'wrap': col.title.length>=20, 'resizing':col.resizing}"
						:style="{'width':col.width}"
						)
						span(@click="m_sortClick(col, $event)") {{col.title}}
						fa-icon(v-if="col.currentSort==1" icon="arrow-up"  style="color:yellow;")
						fa-icon(v-if="col.currentSort==-1" icon="arrow-down" style="color:#52c1fa;")
						span(class="resizer" @mousedown="m_resizeMD($event, col)")
					b-th
				b-tbody(v-show="!d_loading && !d_errMessage")
					b-tr(v-for="(row,ixr) in c_filterData" :key="ixr" :class="row.uploaded?'uploaded':''" )
						b-td(v-if="d_opts.detailView" class="detail" title="Show Additional Fields Below"   )
							a(href="#" @click="m_detailToggle($event, row)" class="sticky-disclosure")
								fa-icon(icon="chevron-right")
						b-td(v-for="(col,cid) in c_colsVisible" :key="col.field" :class="col.readOnly?'disabledClass':''"  @dblclick="m_dblClickCell($event,col,row,rid,cid)")
							kt-custom-multiselect(v-if="col.multiselect&&m_editColumn(col.field,row) &&!col.readOnly" :id="col.field" size="sm" :p_options="c_selectOptions" :p_value="row[col.field]" @input="m_multiSelectInput($event,col)")
							kt-table-column-edit(v-else-if="m_editColumn(col.field,row) &&!col.readOnly" :p_col="col" :p_recData="row"  @change="d_recData=$event" :p_appEnt="d_appEnt" @savedNotes="m_savedNotes" @closeNotes="m_closeNotes")
							span(v-else-if="col.linkFn && col.linkFn(0, row, 0)===null"  variant="success" ) {{m_valFmtTbl(col, row)}}
							span(v-else-if="d_opts.openLinksInModal && (col.openOnClick||col.linkFn)" @click="m_openLinkModal(col, row)" class="btn btn-link" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''" ) {{m_valFmtTbl(col, row)}}
							a(v-else-if="col.fn_hrefLink&&row[col.field]"  :href="col.fn_hrefLink(col.datatype,row[col.field])" target="_blank" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''" ) {{m_valFmtTbl(col, row)}}
							a(v-else-if="col.fn_hrefAppLink&&row[col.field]"  :href="col.fn_hrefAppLink(col.datatype,row[col.field].no)" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''" ) {{row[col.field].name}}
							router-link(v-else-if="col.openOnClick" :to="m_linkPath(col, row)" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''" ) {{m_valFmtTbl(col, row)}}
							router-link(v-else-if="col.linkFn" :to="col.linkFn(col, row, $vnode.componentInstance)" :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''") {{m_valFmtTbl(col, row)}}
							//-span(v-else-if="col.htmlFn" v-html="col.htmlFn(row[col.field])")
							span(v-else :class="c_searchMode&&m_searchMatched(row,col.field)?'matched':''") {{m_valFmtTbl(col, row)}}
						b-td
			//- Aggregates
			div(v-show="!d_loading" v-if="c_colsAggr.length>0 && d_filteredData.length>0" class="kt-table-aggr")
				div(v-for="col in c_colsAggr" :key="col.field")
					div(v-if="d_filteredData.length>0" )
						span {{col.aggrTitle}}
						b {{c_filteredValue}}
					div(v-if="d_filteredData.length>0" )
						span Current Page {{d_dataParams.search? ' (Search Result)':''}}: 
						b  {{c_pageValue}}
					div(v-if="d_filters")
						span Filtered Value: 
						b  {{c_filteredValue}}
			//- Loading
			kt-spinner(v-if="d_loading" :p_txt="d_appEnt.label")
			//- Error
			div(v-if="d_errMessage" class="error")
				p(class="text-danger") Something went wrong ☹
				p(class="my-1 text-grey5") {{d_errMessage}}	
				p() Please try again or refresh your browser session.
			//- No Data
			div(v-if="d_filteredData.length==0" class="nodata")
				| No {{d_appEnt.label}} found 
				| {{d_dataParams.search? ' matching the searched value': c_isScoped ? ' for the current scope' : ''}}		
		//- Pagination
		kt-pagination(v-if="!d_altViewKey" :p_prntRef="{dp: d_dataParams, da: d_dataAggr,filtered:c_filteredCount}" :p_getData="m_getData" )

</template>
<script>
import util, {fn_profilePicURL,kbdpRecord, fn_lkpRefIdName, fn_resizeColHelper,kbdpAlertInfo} from "@/utils/util.js";
import {fn_getAppNotes,fn_saveRecord,fn_getRecord,fn_getTableData} from "@/utils/api.js";
import KTToolbar from "@/components/Ctrl/KT-Toolbar.vue";
import KTPagination from "@/components/Ctrl/KT-Pagination.vue";
import {refData,userInfo,fn_appEnt, userSettings,api_baseURL} from "@/utils/ref-data.js";
import KTGanttView from "@/components/Ctrl/KT-GanttView.vue";
import KTMapView from "@/components/Ctrl/KT-MapHome.vue";
import {Resize} from "vue-resizer";
import { eventBus } from '@/main';
import KTTableColumnEdit from "@/components/Ctrl/KT-TableColumnEdit.vue";

export default {
	name: "kt-table",
	components: {
		"kt-toolbar": KTToolbar,
		"kt-pagination": KTPagination,
		"kt-ganttView":KTGanttView,
		"kt-mapView":KTMapView,
		"resize":Resize,
		"kt-table-column-edit":KTTableColumnEdit,
		},
	created() {

		console.log('In KT-Table');
		this.d_appEnt = fn_appEnt(this.p_appEntKey);
		this.d_id = "kt-table-" + this.d_appEnt.key + this.p_tblIdKey;
		this.d_tableName = this.d_appEnt.label;
		this.d_ktTable= "kt-table-" + this.d_appEnt.key;
		eventBus.$emit('table', this.d_appEnt.label);
		util.fn_getUserOpts(this.d_id, 'tbl').then(() => {
			fn_getOpts(this);
			fn_getCols(this);
			this.d_qryPrms.Archived=false;
			fn_getData(this);
			
			//console.log('In table created d_refData');
			//console.log(this.d_refData);
	
		});
		
	   this.fn_updateEditedColumns = this.fn_debounce((cols) => {
             this.d_editedColumns = cols;
        }, 250);
		
      if (this.d_appEnt.key === "extr") {
        eventBus.$on("businessCardUpload", (data) => {
       if (!data || typeof data !== "object") return;

       const newBusinessCard = {
           ...data,
          uploaded: true
       };

    // Insert at top (reactive)
    this.d_data = [newBusinessCard, ...this.d_data];

    // Debounced update of edited columns
    const cols = Object.keys(newBusinessCard);
    this.fn_updateEditedColumns(cols);
	this.d_editedRowId = 0;
  });
  
     }

  },
	mounted() {},
	beforeDestroy() {
        eventBus.$off("businessCardUpload");
      },
	data() {
		return {
			d_appEnt: null,
			d_id: null,
			d_tableName:null,
			d_opts: {},
			d_cols: [],
			d_data: [],
			d_mapData: [],
			d_filters:null,
			d_refData: {},
			d_dataParams: {
				offset: 0,
				limit: this.p_opts.pageSize || 25,
				order: [],
				search: null,
			},
			d_dataAggr: {
						colAggrNotFiltered:0,
						totalCountNotFiltered:0
			},
			d_qryPrms: this.p_qryPrms || {},
			d_loading: true,
			d_errMessage: null,
			d_altViewKey:null,
			d_taskData:{taskSource:'All', teamMember:null},
			d_columnSortType:{},
			d_sortType:1,
			d_filteredValue:0,
			d_pageValue:0,
			d_filteredData:[],
			d_pageData:[],
			d_searchMatches:[],
			d_searchMode:false,
			d_ktTable:null,
			d_editedRowId:null,
			d_editColumn:false,
			d_editColumnName:null,
			d_editRowIdx:null,
			d_editRowNo:null,
			d_editColumnValue:null,
			d_previousRow:null,
			d_editedRow:null,
			d_editedColumns:[],
			d_disallowedColumns:['designerAccounts','competitors','assignedTeamMembers','externalContacts','taskAssignees',
								'createdById','createdUTC','updatedBy','updatedUTC','psqft'],

		};
	},
	props: {
		p_appEntKey: {type: String, required: true},
		p_tblIdKey: {type: String, default: ''},
		p_type: String,
		p_opts: Object,
		p_cols: Array,
		p_tbNote: String,
		p_tbInfo: String,
		p_qryPrms: Object,
		p_hdrKey: String,
		p_skipLoad: Boolean,
		p_getDataFn: Function,
		p_popupParams:Object,
		p_style:Object,
		p_showBtns:Object,
  sliderWidth: {
    type: Number,
    default: 20,
  },
  // height of the container
  // units: px
  height: {
    type: Number,
    default: 400,
  },
  // width of the container
  // units: px
  width: {
    type: Number,
    default: 400,
  },
  // color of the slider
  sliderColor: {
    type: String,
    default: "#6f808d",
  },
  // bg color of the slider
  sliderBgColor: {
    type: String,
    default: "#1f2e3a",
  },
  // color of the slider on hover
  sliderHoverColor: {
    type: String,
    default: "#6f808d",
  },
  // bg color of the slider on hover
  sliderBgHoverColor: {
    type: String,
    default: "#16222a",
  }
	},
	computed: {
		c_filters() {
			var filter_data = {};
			var values;
			var min;
			var max;
			
		if(this.d_cols.length>0){
			this.d_cols.forEach(col => {
				if(!col) return;
				filter_data[col.field] = {
					name: col.title,
					data: [],
					hasRefData: false,
					range: false,
					min:null,
					max:null,
					date: col.field.includes('Date')||col.field.includes('UTC'),
					datatype:col.datatype,
					selectedCount:0
				};

				let refID = col._refId ?? null;
				let refName = col._refName ?? null;

				if (col?.datatype === 'num') {
					filter_data[col.field].range = true;
				}

				if ('_refData' in col && col?._refData.length > 0) {
					filter_data[col.field].hasRefData = true;
					
						
					col._refData.forEach(obj => {
						const hasID = 'id' in obj;

						if (refID || refName && !hasID) {
							refID = refID ?? refName.split('Name')[0]+'Id';
							refName = refName ?? refID.split('Id')[0]+'Name';

							filter_data[col.field].data.push({
								id: obj[refID],
								name: obj[refName]
							});
						}
						else {
							filter_data[col.field].data.push({
								id: obj.id,
								name: obj.name
							});
						}
					});
				}
			});
		}

			var data=this.d_data||[];
			data.forEach(rowObject => {
				for(const key in rowObject) {
					if (filter_data[key]) {
						if (!filter_data[key].hasRefData) {
								if(!(filter_data[key].data.map(d=>d.value).includes(rowObject[key]))) filter_data[key].data.push({value:rowObject[key]});
							} 
							
						if (filter_data[key].range) {
							values=filter_data[key].data.map(d=>{return d.value;});
							min = Math.min(...values);
							max = Math.max(...values);

							if (min && max) {
								filter_data[key].actualMin=min;
								filter_data[key].actualMax=max;
								filter_data[key].min=min;
								filter_data[key].max=max;
							}
						}
						
							if (filter_data[key].date) {
								values=filter_data[key].data.map(d=>{return new Date(d.value);});
								min = Math.min(...values);
								max = Math.max(...values);
							if (min && max) {
								filter_data[key].actualMin=new Date(min).toISOString().slice(0,10);
								filter_data[key].actualMax=new Date(max).toISOString().slice(0,10);
								filter_data[key].min=new Date(min).toISOString().slice(0,10);
								filter_data[key].max=new Date(max).toISOString().slice(0,10);

							}
						}

					}


				}
				
			});
			

			this.d_cols.forEach(col => {
				var colFilter=filter_data[col.field];
				if(colFilter&&colFilter.data.length==0) delete filter_data[col.field];
				});	
	
			
			console.log('filter Data');
			console.log(filter_data);
			return filter_data
		},
		c_filterData() {
		
		console.log('this.d_data1');
		console.log(this.d_data);
		
		
		// Quick Filters
		
		
			var v_quickFilterData=this.d_data?[...this.d_data.filter(fn_quickFilter,this)]:[];
			this.d_dataAggr.totalCountNotFiltered = v_quickFilterData?v_quickFilterData.length:0;
			
			if(['Opportunities','Projects'].includes(this.d_tableName)) {
			this.d_dataAggr.colAggrNotFiltered=0;
			v_quickFilterData.forEach(d=>{if(d.value) this.d_dataAggr.colAggrNotFiltered=this.d_dataAggr.colAggrNotFiltered+d.value;});
			}
		
		

		// generic Filters
		var v_filteredData=v_quickFilterData.length?[...v_quickFilterData.filter(fn_genericFilter,this)]:[];			
				
				
		//- Searching
		this.d_searchMatches.length=0;
		if(this.d_searchMode) {
			this.d_filteredValue=0;
			var v_filteredSearchedData=v_filteredData.filter(fn_searchFilter,this);
			v_filteredData=[...v_filteredSearchedData];
			} 
		
			
		//- Pagination
		
	
	if(v_filteredData.length>0) {	
		if(this.d_dataParams.offset>v_filteredData.length) 
			this.d_dataParams.offset = parseInt(v_filteredData.length/this.d_dataParams.limit)*this.d_dataParams.limit;
		var v_pageStart=this.d_dataParams.offset;
		var v_pageEnd=v_pageStart+this.d_dataParams.limit;
		var v_pageData=v_filteredData.slice(v_pageStart,v_pageEnd);
		v_pageData.forEach(d=>{if(d.value) this.d_pageValue=this.d_pageValue+d.value;});
		this.d_dataAggr.totalCountFiltered = v_filteredData.length;
		this.d_filteredData=[...v_filteredData];
		this.d_pageData=[...v_pageData];
		} else {this.d_filteredData=[];
				this.d_dataAggr.totalCountFiltered=0;
				this.d_pageData=[];
				}
		

		return v_pageData;
		
			
	},
		c_colsVisible() {
			return this.d_cols.filter(x => x.visible||x.required);
		},
		c_colsAggr() {return this.d_cols.filter(x => x.showAggr=='sum');},
		c_tblStyle() {
			let sh = this.d_opts.staticHeight;
			if (sh) return `height:${sh}px`;

			let mh = this.d_opts.maxHeight;
			if (mh) return `max-height:${mh}px`;

			//return null;
            return `max-height:500px`;
		},
		c_tblMinWidth() {
			let mw = this.d_opts.width;
			if (mw && !this.p_popupParams) return mw;
			let cv = this.c_colsVisible.length;
			if (cv < 4) return null;
			return (cv < 8 ? 500 : cv < 12 ? 800 : 1200) + 'px';
		},
		c_isScoped() {
			//called when there is no data
			let qp = this.d_qryPrms;
			if (!qp) return false;
			let vals = Object.keys(qp).map(k => qp[k]);
			return vals.filter(x => x !== null).length > 0;
		},
		c_filteredCount(){ return this.d_filters?this.d_filteredData.length:null;},
		c_filteredValue(){	var data=this.d_filteredData.map(d=>{return parseFloat(d.value);});
							console.log('c_filteredValue');
							console.log(data);
							console.log(util.fn_calcSum(data, true));
							return util.fn_fmtMoney(util.fn_calcSum(data, true));
						},
		c_pageValue(){	var data=this.d_pageData.map(d=>{return parseFloat(d.value);});
						console.log('c_pageValue');
						console.log(data);
						console.log(util.fn_calcSum(data, true));
						return util.fn_fmtMoney(util.fn_calcSum(data, true));
						},
		c_searchMode(){return this.d_searchMode;},
		c_totalValue(){return this.d_dataAggr.colAggrNotFiltered;},
		c_editedColumns(){return this.d_editedColumns.length>0;},
		c_styleTop(){ return this.p_style?this.p_style.top:null;},
		c_styleLeft(){ return this.p_style?this.p_style.left:null;},
		c_stylePosition(){ return this.p_style?'fixed':null;},
		
	},
	methods: {
		
		m_clearFilters(data){
			this.d_filters=null;
		},
		m_filterTableData(data) {
			console.log('d_filters');
			
			this.d_filters = {
				...data
			};
			
			// Make d_filter null if an empty filter.
			for (const key in this.d_filters) {
				if(this.d_filters[key]?.range &&(this.d_filters[key]?.min>0||this.d_filters[key]?.max>0))
					return ;
				else
				if(this.d_filters[key]?.date && (this.d_filters[key].min||this.d_filters[key].max))
					return;
				else
				if (this.d_filters[key].data?.length) return;
				
				
				}
				
			this.d_filters=null;	
			
		},
		m_valFmtTbl(col, row) {
			let val = row[col.field];
			if (col.valFmtFn) return col.valFmtFn(val, col, row, this);
			else return val;
		},
		m_linkPath(col, row) {
			let numKeyField = this.d_cols.filter(x => x._numKey)[0].field;
			let recNo = row[numKeyField];

			return {path: util.fn_hrefVwRec(this.d_appEnt.key, recNo)};
		},
		m_detailToggle(e, row) {
			e.preventDefault();
			let $tr = $(e.target.closest("tr"));

			fn_detailToggle(this, $tr, row);
		},
		m_getData(isRefresh) {
			fn_getData(this, isRefresh);
		},
		m_refresh(){ 
		
		this.d_filters.length=0;
		fn_getData(this);
		},
		m_sortClick(col, e) {
	
		

			var refName;
			var ac;
			var bc;
			

			
			var sortType
			
			
			
			if(col["currentSort"])
				sortType=col["currentSort"]*-1;
			else sortType=1;

			
			this.d_cols.forEach(c=>{c["currentSort"]=0;});
			var colIndex=this.d_cols.findIndex(c=>c.field==col.field);
			this.d_cols[colIndex]["currentSort"]=sortType;
			

				
			this.d_data.sort((a, b) => {
			
				if(col._refId){
					refName=col._refId.replace("Id","Name");

					ac=a[col.field]?this.d_refData[col._refId].filter(r=>r[col._refId]==a[col.field])[0][refName]:' ';
					bc=b[col.field]?this.d_refData[col._refId].filter(r=>r[col._refId]==b[col.field])[0][refName]:' ';

				} else   if(col._refData){
						refName=col.field.replace("Id","Name");
						ac=a[col.field]?col._refData.filter(r=>r.id==a[col.field])[0]["name"]:' ';
						bc=b[col.field]?col._refData.filter(r=>r.id==b[col.field])[0]["name"]:' ';

				} else 	if(col.datatype=='num'||col.datatype=='number') {
							ac = a[col.field]||0;
							bc = b[col.field]||0;
				} else 
						if(col.datatype=='date'||col.field.includes('Date')||col.field.includes('UTC')){
							ac = a[col.field]?new Date(a[col.field]):0;
							bc = b[col.field]?new Date(b[col.field]):0;
				} else if(col.datatype=='checkbox'){
							ac = a[col.field]?a[col.field].toString():' ';
							bc = b[col.field]?b[col.field].toString():' ';
				} else if(['oppr','proj','acct','extr','cmpt','team'].includes(col.datatype)){
							ac = a[col.field]?a[col.field].name.toUpperCase():' ';
							bc = b[col.field]?b[col.field].name.toUpperCase():' ';
				} else {					
						ac = a[col.field]?a[col.field].toUpperCase():' ';
						bc = b[col.field]?b[col.field].toUpperCase():' ';
				}
				
					
					if(ac==bc) return 0;
					if(ac<bc) return -1*sortType;
					return 1*sortType;
					
			});
			
             window.localStorage.setItem(window.location.href+'-sortColumn',JSON.stringify({field:col.field,sortType:sortType*-1}));	

		},
		m_currentUser() {
			let qp = this.d_qryPrms;
			qp.currentUser = !qp.currentUser || null;
			fn_getData(this);
		},
		m_isCu() {
			//Called Externally
			return this.d_qryPrms.currentUser == true;
		},
		m_resizeMD(e, col) {
			//Mouse Down Event
			if (e.button != 0) return;
			if (e.detail > 1) return;

			fn_resizeColHelper(e, col, this.d_opts).then(newWidth => {
				col.width = newWidth;
				let val = {
					_tblW: this.d_opts.width
				};

				this.d_cols.filter(x => x.width).forEach(x => {
					val[x.field] = x.width;
				});
				util.fn_saveUserOpts(this.d_id, 'tableColumnWidths', val);
			});
		},
		m_openLinkModal(col, row) {
			if (col.linkFn) {
				let lnk = col.linkFn(col, row, this) || {};
				if (lnk.appEntKey && lnk.recNo) {
					kbdpRecord.showRecord(lnk.appEntKey, lnk.recNo);
				}
				else if (lnk.prntType && lnk.id) {
					kbdpRecord.showTask(lnk.prntType, lnk.id, row, this.d_refData, null);
				}
			}
			else {
				let numKeyField = this.d_cols.filter(x => x._numKey)[0].field;
				let recNo = row[numKeyField];
				kbdpRecord.showRecord(this.d_appEnt.key, recNo);
			}

		},

		m_loadResp(resp) {
			//Called Externally
			this.d_dataParams.offset = 0;
			fn_loadDataRoutine(this, resp);
		},
		m_dbc_hdrYr(e) {
			let qp = this.d_qryPrms;
			qp.year = e == -1 ? null : e;
			fn_getData(this);
		},
		m_ganttView(){
		this.d_altViewKey='GANTTVIEW';
		},
		m_mapView(){
		this.d_altViewKey='MAPVIEW';
		},
		m_searchMatched(row,col){var matchedRow=this.d_searchMatches.filter(s=>s.row==row[this.d_appEnt.numKey]&&s.col==col)[0];
								return matchedRow?true:false;
								},
		m_searchMode(e){console.log('e');
						console.log(e);
						
						if(e) this.d_searchMode=true;
						else {	this.d_searchMode=false;
								this.d_searchMatches.length=0;
							}
					},
		m_dblClickCell(e,col,row,rid,cid){
		
		if(this.d_qryPrms.dashboardId||this.d_disallowedColumns.includes(col.field)) return;
		e.preventDefault();
		
		if(this.d_editColumn && col.field==this.d_editColumnName&&
			row[this.d_appEnt.numKey]==this.d_editRowNo)
			{
				
				var newRow={...row};
				newRow[this.d_editColumnName]=this.d_editColumnValue;
				if(col.customField) newRow.customData[col.field]=this.d_editColumnValue;
				var rowIdx=this.d_data.findIndex(d=>d[this.d_appEnt.numKey]==this.d_editRowNo);
				this.d_data.splice(rowIdx,1,newRow);
				
				this.d_editMode=false;
				this.d_editColumn=false;
				this.d_editColumnName=null;
				this.d_editRowNo=null;
				this.d_editedRow=null;
				this.d_editedRowId=null;
				this.d_editedColumns.pop();
				if(this.d_editedColumns.length==0) window.sessionStorage.removeItem('unsaved-changes');
			return
		} 
			
			if(this.d_editColumn && row[this.d_appEnt.numKey] != this.d_editRowNo){						
				kbdpAlertInfo(this,"Save changes","Please Save or Cancel changes before proceeding to a different record.");						
				return						
				}
			if(!this.d_editColumn) this.d_previousRow={...row};
			
			console.log('In m_dblClickCell2');
			this.d_editColumn=true;
			this.d_editColumnName=col.field;
			this.d_editedColumns.push(col.field);
			this.d_editRowNo=row[this.d_appEnt.numKey];
			this.d_editColumnValue=row[col.field];
			this.d_editedRowId=this.d_data.findIndex(d=>row[this.d_appEnt.numKey]==this.d_editRowNo);
			window.sessionStorage.setItem('unsaved-changes', true);
		
		},
		m_editColumn(field,row){return this.d_editColumn&&this.d_editColumnName==field&&
										row[this.d_appEnt.numKey]==this.d_editRowNo;
							},
		m_saveTableEdit() {
			var editedRow=null;
			editedRow=this.d_data.filter(r=>r[this.d_appEnt.numKey]==this.d_editRowNo)[0];
			if(editedRow) {
				var appEntName=this.d_appEnt.name;
				var recId=editedRow[this.d_appEnt.idKey];
				fn_saveRecord(appEntName, recId, editedRow);
				}
			
			this.d_editColumn=false;
			this.d_editColumnName=null;
			this.d_editRowNo=null;
			this.d_editedRow=null;
			this.d_editedColumns=new Array();
			window.sessionStorage.removeItem('unsaved-changes');
		
		},
		m_removeEdit(){
			this.d_editColumn=false;
			this.d_editColumnName=null;
			this.d_editRowNo=null;
			this.d_editedRow=null;
			this.d_editedRowId=null;
		},
		m_cancelTableEdit(){
		console.log("In m_cancelTableEdit")
		
	
			
		var rowIdx=this.d_data.findIndex(d=>d[this.d_appEnt.numKey]==this.d_editRowNo);
		this.d_data.splice(rowIdx,1,this.d_previousRow);	
		
		this.d_editColumn=false;
		this.d_editColumnName=null;
		this.d_editRowNo=null;
		this.d_editedRow=null;
        this.d_editedRowId=null;		
        this.d_editedColumns=new Array();
		window.sessionStorage.removeItem('unsaved-changes');
		
		},						
		m_parsePopupParams(popupParams, d_cols){
				//var p_value;
				var p_val;
				var field;
				var fields=[]
				var filters={};
				var value;
				var refName;
				var minValue;
				var maxValue;
				var valueObj;
				Object.keys(popupParams).forEach(k=>{
					
					var data=[];
					value=popupParams[k];
					var col=d_cols.filter(c=>(c.title&&c.title==k))[0];
					field=col.field;
					fields.push(field);
					p_val=popupParams[k];
					var p_value;
					if(col.datatype=='date') {
						minValue=p_val[0]+"-01-01";
						maxValue=p_val[0]+"-12-31";
						valueObj={date:true,min:minValue,max:maxValue,datatype:col.datatype};
						filters[field]=valueObj;
					} else 
						if(col.datatype=='num') {
							p_value=p_val[0].replaceAll('sf','');
							p_value=p_value.replaceAll('$','');
							if(p_value.includes('-')) {
								var Values=p_value.split('-');
								minValue=Values[0].replace(/K/g,'000').replace(/M/g,'000000');
								maxValue=Values[1].replace(/K/g,'000').replace(/M/g,'000000');
						} else if(p_value.includes('+')) {
							minValue=p_value.replace('+','').replace(/K/g,'000').replace(/M/g,'000000');
							maxValue=999999999999;
						}
						var min=parseFloat(minValue) + 0.01;
						var max=parseFloat(maxValue);
						valueObj={range:true,min:min,max:max, datatype:col.datatype};
						filters[field]=valueObj;
					} else if(col._refId){
							p_val.forEach(v=>{
							refName=col._refId.replace("Id","Name");
							var colValue=col._refData.filter(r=>r[refName]==v)[0][col._refId];
							data.push(colValue);
							});
							filters[field]={data:[...data],datatype:col.datatype};
					} else if(col._refData) {
						p_val.forEach(v=>{
							var id="id";
							var name="name";
							var colValue=col._refData.filter(r=>r[name]==v)[0][id];
							data.push(colValue);
							});
							filters[field]={data:[...data],datatype:col.datatype};
						} else {p_value=p_val[0];						
								data.push(p_value);
								filters[field]={data:[...data],datatype:col.datatype};
								}
						
			});
			
			
			
		
			if(!Object.keys(popupParams).includes("Due Date")) 
				filters["dueDate"]={date:true,notNull:true,datatype:"data"};
				
			
			
			this.m_clearFilters(null);
			this.m_filterTableData(filters);

		},
		m_savedNotes(latestNotes) {
		   console.log('In m_savedNotes',latestNotes);
		   var rowIdx=this.d_data.findIndex(d=>d[this.d_appEnt.numKey]==this.d_editRowNo);
		   console.log('rowIdx',rowIdx);
		   console.log('this.d_editedRowId',this.d_editedRowId);
		   if(rowIdx != null) 
		      this.d_data[rowIdx].notes = latestNotes;
			
			this.d_editColumn=false;
			this.d_editColumnName=null;
			this.d_editRowNo=null;
			this.d_editedRow=null;
			this.d_editedColumns=new Array();
			window.sessionStorage.removeItem('unsaved-changes');

		},
		m_closeNotes(){
			this.d_editColumn=false;
			this.d_editColumnName=null;
			this.d_editRowNo=null;
			this.d_editedRow=null;	
			this.d_editedRowId=null;
			this.d_editedColumns=new Array();
			window.sessionStorage.removeItem('unsaved-changes');
		},
	},
	watch: {
		p_qryPrms(nv, ov) {
		

			this.d_qryPrms={...nv};
			this.d_dataParams.offset = 0;
			
			if((this.d_qryPrms.withArchived&&!ov.withArchived)||this.d_qryPrms.related){
				fn_getData(this);		
			}
			
		},
		p_opts(nv, ov) {Object.keys(nv).forEach(k => {this.d_opts[k] = nv[k];});},
		
		
		p_popupParams(nv,ov){
		if(nv) {	
				this.d_cols.forEach(col => {col.visible=this.p_cols.filter(c=>c.field==col.field)[0]["visible"];});
				this.m_parsePopupParams(nv.filter, this.d_cols);
				}
		},
		
	}
};

function fn_getOpts(vc) {
	let opts = {
		detailView: true,
		staticHeight: null,
		maxHeight: null,
		pageSize: 25,
		enableSearch: true,
		enableCUFilter: false,
		width: null,
		openLinksInModal: null, //To open links in modal instead of router-link
	};
	Object.keys(vc.p_opts).forEach(k => {
		opts[k] = vc.p_opts[k];
	});
	vc.d_opts = opts;

	let usrOpts = userSettings.userOptions;
	console.log('In fn_getOpts');
	console.log(userSettings.userOptions);


	opts.colOpts = {
		visible: usrOpts['tableColumnsVisible'][vc.d_id],
		widths: usrOpts['tableColumnWidths'][vc.d_id],
		sorts: usrOpts['tableColumnSorts'][vc.d_id],
		readOnly:usrOpts['tableReadOnlyColumns'][vc.d_id],
		required:usrOpts['tableRequiredColumns'][vc.d_id],
	
	};

	console.log('opts.colOpts');
	console.log(opts.colOpts);
	opts.width = opts.colOpts.widths._tblW || null;

	let dpOrder = vc.d_dataParams.order = [];
	let sorts = opts.colOpts.sorts;
	Object.keys(sorts).forEach(k => {
		dpOrder.push({col: k, dir: sorts[k]});
	});
}
function fn_getCols(vc) {
 
	let cols = vc.p_cols.map(c => ({...c})); //Need to do 1 level shallow copy. No need to do a full deep copy,
	let colOpts = vc.d_opts.colOpts;
	let cov = colOpts.visible;
	let readOnlyColumns = colOpts.readOnly?colOpts.readOnly:[];
	//let requiredColumns = colOpts.required.map(c=>{return c.field;});
	let requiredColumns = colOpts.required?colOpts.required.map(c=>{return c.field;}):[];
	cols.forEach(col => {
		if (col._numKey) {
			col.tdClass = "td-num-key";
			let srn = userSettings.userOptions.showRecordNumbers;
			if (srn != undefined) col.default = srn;
		}

		col.title = col.title || util.fn_humanizeLabel(col.field);
		
	
	if(!vc.p_popupParams){

		if (cov._all)
			col.visible = true;
		else if (cov._defaults)
			col.visible = (col.default === true);
		else if (cov[col.field] !== undefined)
			col.visible = cov[col.field];
		else
			col.visible = (col.default === true);
			
	}

		col.width = colOpts.widths[col.field] || null;
		col.sort = colOpts.sorts[col.field] || null;

		col.resizing = null;

		if (col.title.endsWith(" Date")) {
			if(!col.valFmtFn) col.valFmtFn = (val) => {return util.fn_fmtDt(val);};
		}
		else if (col.title.endsWith(" UTC")) {
			col.tdClass = "td-dtm";
			col.valFmtFn = (val) => {return util.fn_fmtDtm(val);};
		}
		else if (col.field.endsWith('tedById')) {
			col.tdClass = "td-usr";
		}
		else if (col.datatype=='time') {
			col.valFmtFn = (val) => {return val?util.fn_timeFmt(val):null;};
		}
		else if (col._refData) {
			col.valFmtFn = (val) => {
				return fn_lkpRefIdName(col._refData, col, val); //Local Ref Data
			};
		}
		else if(col.datatype=="tel") 
		col.valFmtFn = (val) => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;};

	//- ReadOnly, super Read only.
		col['readOnly']=false;
		col['required']=false;
		console.log('requiredColumns');
		console.log(requiredColumns);
		if(readOnlyColumns.includes(col.field)) col.readOnly=true;
		if(requiredColumns.includes(col.field)) col.required=true;
		
		
	});
	delete vc.d_opts.colOpts; //No need to keep it arround
	vc.d_cols = cols;

}

function fn_getData(vc, isRefresh) {
	vc.d_loading = true;
	// console.log('fn_getData-----', 'skipload: ', vc.p_skipLoad || false);


	if (vc.p_skipLoad) {
		return;
	}

	let dp = vc.d_dataParams;
	//let reqPrms = {offset: dp.offset, limit: dp.limit, search: dp.search};
	let reqPrms = {offset: 0, limit: 10000, search: dp.search};
	if (dp.order.length) reqPrms.order = dp.order.map(x => x.col + '.' + x.dir).join(',');
	if (isRefresh === true) reqPrms.refresh = true;

	let qp = vc.d_qryPrms;
	
	if (qp &&(qp.dashboardId||qp.related)) {Object.keys(qp).forEach(k => (reqPrms[k] = qp[k]));}
	if (qp.withArchived) {
		if(qp.opportunityStatusIds) reqPrms['opportunityStatusIds'] = qp.opportunityStatusIds ;
		if(qp.projectStatusIds) reqPrms['projectStatusIds'] = qp.projectStatusIds ;
		}
	if(vc.p_popupParams) reqPrms['opportunityStatusIds'] = 'ALL';
	if (vc.p_getDataFn) {
		console.log("In p_getData");
		console.log("reqPrms");
		vc.p_getDataFn(reqPrms).then(resp => {
			console.log(resp.rows);
			fn_loadDataRoutine(vc, resp);
		});
	}
	else {
		let appEntName = vc.d_appEnt.label.toLowerCase().replace(" ", "");
		console.log("In fn_getTableData");
		console.log(vc.p_tbInfo||' '||vc.p_tblIdKey);
		fn_getTableData(appEntName, reqPrms).then(resp => {
			console.log(resp.rows);
			fn_loadDataRoutine(vc, resp);

		});
	}

	
	
	
	
}

function fn_loadDataRoutine(vc, resp) {
	if (resp.error) {
		vc.d_errMessage = resp.error;
		vc.d_loading = false;
		return;
	}
	vc.d_data = resp.rows;
	vc.$parent.d_data=resp;
	vc.d_refData = resp.refData;
	console.log('In fn_loadDataRoutine');
	console.log(vc.d_refData);

	vc.d_dataAggr.totalCountNotFiltered = resp.totalCountNotFiltered;
	vc.d_dataAggr.totalCountFiltered = resp.totalCountFiltered; //Important, not the same as resp.rows.lengh
	vc.d_dataAggr.colAggrNotFiltered = resp.colAggrNotFiltered;


	vc.d_cols.forEach(col => {
		if (!col._refId) return;
		let rd = vc.d_refData[col._refId];

		if (!rd && col._refData) return;
		else if (!rd) {
			rd = vc.d_refData[col._refId] = [];
		}
		col._refData = rd;//Remote Ref Data, Set reference here at the col here to avoid cpu cycles for each row/card rendered

		if (col.valFmtFn) return;

		col.valFmtFn = (val) => {
			return fn_lkpRefIdName(col._refData, col, val);
		};
		

	});

	//vc.d_cols.filter(x => x.showAggr).forEach(col => fn_getColAggrData(vc, col));
	fn_addCustomData(vc);
	
	if(window.localStorage.getItem(window.location.href+'-sortColumn')){
			var tableSort=JSON.parse(window.localStorage.getItem(window.location.href+'-sortColumn'));
			var colIndex=vc.d_cols.findIndex(c=>c.field==tableSort.field);
			var col=vc.d_cols[colIndex];
			if(col){
				vc.d_cols[colIndex]["currentSort"]=tableSort.sortType;
				console.log('calling sort');
				vc.m_sortClick(col,null);
				}
			}

	vc.d_errMessage = null;
	vc.d_loading = null;
	
	
	if(vc.p_popupParams) {
		vc.m_parsePopupParams(vc.p_popupParams.filter,vc.d_cols);
	}	
}
function fn_addCustomData(vc){
	vc.d_data.forEach(r=>{
	var customData=r.customData;
		if(customData){
			Object.keys(customData).forEach(cf=>{
				r[cf]=customData[cf];
				});
			}
		
		/*
		//Calculated fields		
		if (vc.d_appEnt.key === 'oppr') {
			const value = Number(r.value);
			const size = Number(r.projectSize);

			if (value > 0 && size > 0) {
				r.psqft = (value / size).toFixed(2);
			} else {
				r.psqft = ""; // or null, or "0.00"
			}
		}
		*/
			
	});
}
function fn_getColAggrData(vc, col) {
	let colAaggrNf = vc.d_dataAggr.colAggrNotFiltered;
	//if(!colAaggrNf) return;
	col.aggr = {};
	switch (col.showAggr) {
		case "sum": {
			let sumNF = colAaggrNf.sums[col.field] || 0;

			col.aggr.title = "Total " + col.title + ": ";
			col.aggr.value = col.valFmtFn(sumNF);

			let data = vc.d_pageData.map(x => x[col.field]);
			let sumCurr = util.fn_calcSum(data, true); //current page or filter
			if (sumCurr != sumNF) {
				col.aggr.valueCurr = col.valFmtFn(sumCurr);
			}
			break;
		}
	}
	console.log('fn_getColAggrData');
	console.log(col);
}

function fn_detailToggle(vc, $tr, row) {
	$tr.toggleClass("detail-open");

	if (!$tr.is(".detail-open")) {
		//$tr.next("tr.detail-view").remove();
		$("tr.detail-view").remove();
		return;
	}

let $tr_detail = $("<tr>", {class: "detail-view"});
	
	//Add photo to use first 3 columns if photoURL exists.
	if(row.photoURL||row.profilePicturePath){
		let colspan=2;
		let $photoImg = $("<img>");
		if(row.profilePicturePath) {
			$photoImg.attr("src",api_baseURL + 'profilePicture?tmid='+row.teamMemberId);
			}
		else {$photoImg.attr("src",row.photoURL);}
		if(/^(team|extr)$/.test(vc.p_appEntKey))
			$photoImg.attr("style","width:150px;height:150px;border-radius:50%;object-fit: cover");
		else $photoImg.attr("style","width:200px;height:125px;border-radius:8px;");
		let $photoTd = $("<td>", {colspan}).append($photoImg);
		$tr_detail.append($photoTd);
		}
	let cols = vc.d_cols.filter(x => !x.visible); //No need to show columns already seen in regular view
	let $div = $("<div>",{style:"display:flex;flex-wrap:wrap;border-left:0.1em solid rgba(77,163,255,.3);padding-left:0.5em;margin-left:0.3em;margin-bottom:1em;"});
	cols.forEach(col => {
		let val = row[col.field];
		if (val === undefined) return;
		let fldFmt = util.fn_humanizeLabel(col.field); //Keep here, not always same as col.title
		let valFmt = vc.m_valFmtTbl(col, row);
		let $span = $("<span>",{style:"display: flex;flex: 0 0 50%;padding: 0.3em 0.5em;"}).append(`<b>${fldFmt}: </b> ${valFmt}`);
		$div.append($span);
	});

	//let colspan = vc.d_cols.length - cols.length + 1;
	let colspan=10;
	let $td = $("<td>", {colspan}).append($div);
	$tr_detail.append($td);
	$tr.after($tr_detail);
	
	
	//Add kt-notes	
	let $notesTr = $("<tr>", {class: "detail-view"});
	$notesTr.attr("style","border:none;");
	$tr_detail.after($notesTr);
	
	
	let $notesDiv = $("<div>");
	let $notesHeader=$("<span>").append(`<b>Notes/Comments:`);
	$notesDiv.append($notesHeader);
	$notesDiv.attr("style","max-height:300px;overflow:auto;");
	var notes=[];
	var params={
			recordContext:vc.d_appEnt.idKey,
			recordId:row[vc.d_appEnt.idKey]
			};
			fn_getAppNotes(params).then((resp) =>
				{
				if (!resp.error && resp.recordData) 
				{
				notes=[...resp.recordData];
				if(notes.length>0) {
					resp.recordData.forEach(n=>{
					let $noteDiv = $("<div>",{class:"d-flex"});
					let teamMemberName=n.teamMemberId==vc.d_teamMemberId?'You':n.teamMemberName;  
					let createdUTC=new Date(n.createdUTC+'Z').toLocaleString();
					let $img = $("<img>", {class:"small-round-profile"});
					$img.attr("src",fn_profilePicURL(n.teamMemberId));
					let $nameSpan = $("<span>").append(teamMemberName+"    "+createdUTC);
					let $noteSpan = $("<span>").append(n.note);				
					$noteDiv.append($img);
					$noteDiv.append($nameSpan);
					$notesDiv.append($noteDiv);
					$notesDiv.append($noteSpan);
					});
				} else $notesDiv.append($("<span>").append("No Notes")); 
			} else $notesDiv.append($("<span>").append("No Notes")); 
           });
	
	colspan=5;	   
	let $ktNotesTd = $("<td>", {colspan}).append($notesDiv);
	let $ktNotesTr = $("<tr>", {class: "detail-view"}).append($ktNotesTd);
	$notesTr.after($ktNotesTr);
	
}
function fn_quickFilter(data){
			
			//- Team Member Filter
				if(this.d_qryPrms.teamMemberId){
					var teamMemberId=this.d_qryPrms.teamMemberId;
					var assignedTeamMembers=(data.assignedTeamMembers||[]).map(t=>{return t.teamMemberId;});
					var teamMembers=(data.teamMembers||[]).map(t=>{return t.teamMemberId;});
					
					if((['Opportunities','Accounts','Projects'].includes(this.d_tableName)) &&
						!(assignedTeamMembers.includes(teamMemberId)))
						return false;
					
					if(this.d_tableName=='Contacts' &&
						!(teamMembers.includes(teamMemberId)))
						return false;
						
					if(this.d_tableName=='Competitors' &&
						!([data.createdById,data.updatedById].includes(teamMemberId)))
						return false;						
						
				
				}
				
			//- Quick Opportunity Stage Filter
				if(this.d_tableName=='Opportunities' && 
					this.d_qryPrms.opportunityTypeId &&
					this.d_qryPrms.opportunityTypeId != data.opportunityTypeId) return false;
					
			//- Quick Status Filter
				
				
				if(this.d_tableName=='Opportunities'&& this.d_qryPrms.opportunityStatusIds) {
					console.log('In opportunities quick filters')
					var OStatusIdArray=JSON.parse(this.d_qryPrms.opportunityStatusIds);
					console.log(OStatusIdArray);
					console.log(this.d_qryPrms.opportunityStatusIds);
					if(!(OStatusIdArray.includes(data.opportunityStatusId))){
						console.log('In false')
						return false;
						}
				}
				
						
				if(this.d_tableName=='Projects' && this.d_qryPrms.projectStatusIds) {
					var PStatusIdArray=JSON.parse(this.d_qryPrms.projectStatusIds);
					if(!(PStatusIdArray.includes(data.projectStatusId))) return false;
					}
					
					

			//-  Quick Due Date FIlter	
			if(this.d_tableName=='Opportunities' && this.d_qryPrms.dueDate){
					console.log('In dueDate filter');
					console.log(this.d_qryPrms);
					var dueDate=new Date(this.d_qryPrms.dueDate);
					//var dueDate=new Date(this.d_dueDate);
					if(data.dueDate) var dataDueDate=new Date(data.dueDate); else return false;
					var today=new Date();
					if(dueDate <= today && dataDueDate > today) return false;
					if(!this.d_qryPrms.dueAfter && dueDate > today &&  (dataDueDate < today ||dataDueDate > dueDate)) return false;
					if(this.d_qryPrms.dueAfter && dataDueDate <= dueDate) return false;
				}
				
			console.log('About to quick filter Contacts');
				
			if (this.d_tableName === 'Contacts' && this.d_qryPrms.lastContactDateFilter) {

				const startDate = this.d_qryPrms.startDate;
				const endDate = this.d_qryPrms.endDate;
				const recordDate = data.lastContactDate;

				// Exclude inactive contacts
				if (data.inactive) return false;

				// Filter: "never contacted"
				if (!startDate && recordDate) return false;

				// Filter: "contacted within X days"
				if (startDate && (!recordDate || recordDate < startDate||recordDate>endDate)) return false;
				}

		return true;
				
}

function fn_genericFilter(data){

				for (const key in this.d_filters) {
					var filter=this.d_filters[key];
					var filterData=filter?.data;
					
					var includesNull=filter.null || filter.notNull;
					if(includesNull) {
						if( !data[key] && filter.notNull) return false;
						if( data[key] && filter.null) return false;
					}
					else
					if(filter?.datatype=="array") {
						var colData=data[key];
						var dataInt=[];
						if(colData){
							var colArray=colData.split(",");
							dataInt=colArray?.filter(item => filterData.includes(item));
							}
						if(!dataInt.length) return false;
					}	
					else
					if (filter?.range  && !includesNull &&
						!(filter?.min <= data[key] && data[key] <= filter?.max)
					) {
						return false;
					}	
					else
					if (filter?.date && !includesNull &&
						!((new Date(data[key])) >= (new Date(filter.min)) &&
						(new Date(data[key])) <= (new Date(filter.max)))
					) {
						return false;
					}			
					else
					if (filterData?.length && !includesNull &&
						!~filterData.indexOf(data[key])
					) {
						return false;
					}


			}
				
				
			//- Team Member Filter
				if(this.d_qryPrms.teamMemberId){
					var teamMemberId=this.d_qryPrms.teamMemberId;
					var assignedTeamMembers=(data.assignedTeamMembers||[]).map(t=>{return t.teamMemberId;});
					var teamMembers=(data.teamMembers||[]).map(t=>{return t.teamMemberId;});
					
					if((['Opportunities','Accounts','Projects'].includes(this.d_tableName)) &&
						!(assignedTeamMembers.includes(teamMemberId)))
						return false;
					
					if(this.d_tableName=='Contacts' &&
						!(teamMembers.includes(teamMemberId)))
						return false;
						
					if(this.d_tableName=='Competitors' &&
						!([data.createdById,data.updatedById].includes(teamMemberId)))
						return false;						
						
				
				}
								
	
	
	return true;
				
}
function fn_searchFilter(data){
	var searchMatched=false;

	var searchString;
	var searchedValue;
	var datatype;
	var field;
	var valFmtFn;
	var fn_hrefAppLink;
	var numKey=this.d_appEnt.numKey;
					
					
					
	searchString=this.d_dataParams.search;
	if(searchString.endsWith("|")) searchString=searchString.substr(0, searchString.length-1);
					
	var regex= new RegExp(searchString,'i');

	this.d_cols.filter(c=>c.visible).forEach(col => {
					
					field=col.field;
					datatype=col.datatype;
					valFmtFn=col.valFmtFn;
					fn_hrefAppLink=col.fn_hrefAppLink;
					if(data[field]){
						searchedValue=data[field];
						if(fn_hrefAppLink) searchedValue=data[field].name;
						if(valFmtFn) searchedValue=valFmtFn(data[field]);
						if(datatype=='num'||datatype=='number') searchedValue=data[field].toString();
						
						
						console.log(`searching for ${searchString} in ${searchedValue}`);
						
						if(regex.test(searchedValue)){
							this.d_searchMatches.push({row:data[numKey],col:field});
							searchMatched=true;
							console.log("search Matched:"+data[numKey]);
							}
						
						}	
					});
				
				if(this.d_searchMode&&!searchMatched) return false;
					
				if(data.value) this.d_filteredValue=this.d_filteredValue+data.value;
				return true;
}
function fn_debounce(fn, delay = 300) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}


</script>

<style scoped lang="less">
.kt-table {
	.kt-table-table {
		font-size: 12.5px;
		overflow-x: auto;
		border-top: solid 0.1em #6c757d;

		&[style*="height"] {
			min-height: 150px;
		}
		&:not([style*="height"]) {
			min-height: calc(100vh - 280px);
			position: relative;
			> table.b-table {
				margin-bottom: 35px;
			}
			> .kt-table-aggr {
				position: absolute;
				bottom: 0;
			}
		}

		> div.loading-spiner,
		> div.error,
		> div.nodata {
			width: 100%;
			font-size: 1em;
			text-align: center;
			padding: 0.5em 0;
		}

		> table.b-table {
			border-bottom: solid 0.1em #dee2e6;
			margin-bottom: 1em;
			width: 100%;

			thead {
				background-color1: #6c757d;
				color: #fff;
				&.popup {background-color: #71AFFF;
					th {border-right: solid 0.1em white;}
				} //#007bff
				&.regular {background-color: #6c757d;
					th {border-right: solid 0.1em #adb5bd;}
				}
				th {
					padding: 0.2em 0.5em;
					vertical-align: middle;
					white-space: nowrap;
					font-weight: unset;

					position: relative;
					min-width: 60px;
					border-right1: solid 0.1em #adb5bd;
					&.wrap {
						white-space: unset;
						min-width: 130px;
					}
					&.th-detail {
						width: 25px;
						min-width: unset;
						border-right: unset;
					}
					&:last-child {
						min-width: unset;
					}

					> span:first-child {
						&:hover {
							cursor: pointer;
							text-decoration: underline;
						}
					}
					> span:nth-child(2) {
						display: inline-block;
						text-align: right;
						width: 10px;
						&.asc::before {
							content: " ↑";
						}
						&.desc::before {
							content: " ↓";
						}
					}
					> span.resizer {
						position: absolute;
						top: 0em;
						bottom: 0em;
						right: -0.5em;
						width: 1em;
						z-index: 100;
						user-select: none;
						// border: solid 0.1em red;
						&:hover {
							cursor: ew-resize;
						}
					}

					&.resizing {
						border-right-color: #fff;
						> span.resizer {
							width: 20em;
							right: -10em;
							height: 20em;
						}
					}
				}
			}
			tbody {
				tr.detail-open td.detail svg {
					transform: rotate(90deg);
				}
				tr.detail-view {
					&:hover {
						background-color: unset;
					}
					td > div {
						display: flex;
						flex-wrap: wrap;

						border-left: solid 0.1em rgba(77, 163, 255, 0.3);
						padding-left: 0.5em;
						margin-left: 0.3em;
						margin-bottom: 1em;

						span {
							display: block;
							flex: 0 0 50%;
							@media (max-width: 576px) {
								flex: 0 0 100%;
							}
							padding: 0.3em 0.5em;

							&:hover {
								background-color: #f8f9fa;
							}
						}
					}
				}
				tr {
					td span {
						word-break: break-all;
					}
					td.td-num-key {
						white-space: nowrap;
					}
					td.td-usr,
					td.td-dtm {
						font-size: 0.9em;
					}
					td span.btn {
						padding: 0;
						font-size: 1em;
						text-align: unset;
					}
				}
			}
		}
	}
	.kt-table-aggr {
		height: 25px;
		display: flex;
		flex-wrap: wrap;
		font-size: 1em;
		padding: 0.2em 0;

		// border: solid 0.1em red;
		> div {
			display: flex;
			flex-wrap: nowrap;
			// border: solid 0.1em blue;
			> div:nth-child(2) {
				margin: auto 0.5em;
				font-size: 0.95em;
				//color: #adb5bd;
			}
		}
	}
	.btn-alt-view {
			font-size: 0.9em;
			margin: 0.25em 0.25em;
			}
	.btn-task-board {
		font-size: 0.8em;
		padding: 0.1em 0.4em;
		margin-left: 0.5em;
		svg {
			margin-right: 0.2em;
			}
		}
			.btn-alt-view {
			min-width: 60px;
			padding: 0em 0.4em;
			margin-right: 0.5em;
			svg {
				margin-right: 0.4em;
				font-size: 0.9em;
			}
		}

		.btn-alt-view {
			font-size: 0.8em;
			margin: 0.25em 0.25em;
		}
	}
	.sticky-headers{
			position: -webkit-sticky;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 2;
		}
table thead {
  padding: 3px;
  position: sticky;
  top: 0;
  z-index: 1;
  &.popup {background-color: #71AFFF;} //#007bff
  &.regular {background-color: #6c757d;}
}
th {
 &.popup {border:1px solid white;}
 }
table thead th:nth-child(2) {
  position: sticky!important;
  left: 0;
  z-index: 3;
  //background-color:#6c757d;
}
/* make disclosure icon Sticky column */
tr > :first-child {
  position: -webkit-sticky;
  position: sticky!important;
  background:#ffffff;   
  left: 0; 
} 
/* make Second Sticky column */ 
tr > :nth-child(2) {
  position: -webkit-sticky;
  position: sticky!important;
  background:#ffffff;   
  left: 0; 
}
.sticky-div {
  position: -webkit-sticky;
  position: sticky;
  background-color:#ffffff;
  bottom:0;
}
.kt-table-totals{
  position: sticky;
  left: 0;
  z-index: 10;
  background: white;
  width:100%;
}
.kt-table-aggr {
		height: 25px;
		display: flex;
		flex-wrap: wrap;
		font-size: 12.5px!important;
		padding: 0.2em 0;
}
.btn-back
	{
			min-width: 50px;
			padding: 0em 0.4em;
			margin-right: 0.5em;
			svg {
				margin-right: 0.4em;
				font-size: 0.9em;
			}
	}
.detail-div{
	display: flex;
    flex-wrap: wrap;
    border-left: 0.1em solid rgba(77,163,255,.3);
    padding-left: 0.5em;
    margin-left: 0.3em;
    margin-bottom: 1em;
	}
.detail-span{
	display: flex;
	flex: 0 0 50%;
    padding: 0.3em 0.5em;
	}
table.sortable thead {
    background-color:#eee;
    color:#666666;
    font-weight: bold;
    cursor: default;
}
.matched {background-color:yellow !important;  //light green: #90ee90
		color:black;
		}
.disabledClass{pointer-events1:none;
			background-color:#e9ecef;    //#F0F0F0;     //#e9ecef;                 //#DCDCDC;
			border:1px solid white;
			cursor1:not-allowed;
			}
.btn-save,
.btn-cancel {
		min-width: 50px;
		padding: 0em 0.4em;
		margin-right: 0.5em;
	}
.statusHeader{max-width:500px;}
.uploaded {
  background: #FFF8E1;       //#E8F5E9;
  color:  #F9A825;            //#2E7D32;
  border: 1px solid #C8E6C9;
  border-radius: 4px;
  padding: 2px 6px;
}
</style>